import { MarketTypes } from 'api/types';
import useApartmentsFilterQuery from './use-aparments-filter-query';
import useApartmentsFilterLimits from './use-apartments-filter-limits';

const useApartmentsFilterLimitsOnboarding = (fetch = true, marketType = MarketTypes.PRIMARY) => {
  const filter = useApartmentsFilterQuery();
  return useApartmentsFilterLimits({ ...filter, marketType }, fetch);
};

export default useApartmentsFilterLimitsOnboarding;
